import { PrimaryButton, Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Prompt, useParams } from 'react-router-dom';
import WizardModeIndicator from '../../../../Util/WizardModeIndicator';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';
import TextField from "../../../../Forms/TextField";
import FeatureSummary from '../../../../Util/FeatureSummary';

const WizardPage = () => {
    const { fieldOfStudyId: fosIdFromParams } = useParams();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const [{ data: fosData, loading: fosLoading }, getFieldOfStudy] = useAxios(
        { url: `scholarships/fields-of-study/${fosIdFromParams}`, method: 'GET' },
        { manual: true },
    );

    const [{ data, loading: submitting }, submitForm] = useAxios(
        { url: 'scholarships/fields-of-study/update' },
        { manual: true },
    );

    useEffect(() => {
        if (fosIdFromParams && !fosLoading) {
            getFieldOfStudy();
        }
    }, [fosIdFromParams]);

    if (fosLoading) {
        return <Spinner className="absolute-center" text="Loading Field of Study Settings..." />;
    }

    return (
        <>
            <WizardModeIndicator paramId={fosIdFromParams} title="Field of Study" />
            <Formik
            validateOnMount={true}
            initialValues={mapInitialValues(fosData)}
            onSubmit={async (values, { resetForm }) => {
                let result;
                result = fosIdFromParams ? await submitForm({
                    url: 'scholarships/fields-of-study/update',
                    method: "put",
                    data: values,
                }) : await submitForm({
                    url: `scholarships/fields-of-study/add`,
                    method: "post",
                    data: values
                });
                resetForm({ values });

                if (!result.isAxiosError) {
                    setShowSuccess(true);
                } else {
                    setShowError(true);
                }
            }}
            isInitialValid={false}
        >
            {({ dirty, isValid, values, handleSubmit }) => {
                console.log({ dirty, isValid, values });
                return (
                    <>
                        {values &&
                            <Form style={{ maxWidth: '800px' }}>
                                <Prompt when={dirty} message="You have unsaved changes, are you sure you want to leave?" />

                                <div style={{ width: '100%' }} className="mt-1">
                                    <TextField
                                        label="Name"
                                        name="name"
                                        required
                                    />
                                    <TextField
                                        label="Detailed Name"
                                        name="detailedName"
                                        required
                                    />
                                    <hr />
                                    <div style={{ display: 'flex' }} className="mt-1">
                                        <PrimaryButton
                                            onClick={() => handleSubmit()}
                                            text="Save"
                                            disabled={!dirty || submitting}
                                        />
                                    </div>
                                </div>
                                <SuccessComponent
                                    successMessage="Field of Study Updated."
                                    showSuccess={showSuccess}
                                    setShowSuccess={setShowSuccess}
                                />
                                <ErrorComponent
                                    errorMessage="Errors in form, check all tabs for highlighted fields."
                                    showError={showError}
                                    setShowError={setShowError}
                                />
                                <FeatureSummary
                                    label="About Fields of Study"
                                    summary="Create or edit fields of study categories used for scholarship matching. Each field has a short name and a detailed name for display purposes."
                                />
                                <div></div>
                            </Form>
                        }
                    </>
                );
            }}
        </Formik>
        </>
    );
};

function mapInitialValues(data) {
    return data && Object.keys(data).length ? { ...data } : { name: "" };
}

export default WizardPage;
